

export const peerlessData = [

    {
        id: 1,
        image: 'HairService.png',
        serviceName: 'Hair Services'
    },

    {
        id: 2,
        image: 'HairAccessories.png',
        serviceName: 'Hair Accessories'
    },

    {
        id: 3,
        image: 'AppDev.png',
        serviceName: 'App & Web Dev'
    },

    {
        id: 4,
        image: 'Graphics.png',
        serviceName: 'Graphic Designs'
    },
    
    {
        id: 5,
        image: 'Training.png',
        serviceName: 'Training School'
    }
]

export const peerlessDataForMembers = [

    {
        id: 1,
        image: 'Sales Rep.png',
        nameOfMember: 'Adigho Janet',
        serviceName: 'SALES REP'
        
    },

    {
        id: 2,
        image: 'Designer.png',
        nameOfMember: 'Ayo Ose',
        serviceName: 'APP DEVELOPER'
    },

    {
        id: 3,
        image: 'Lawyer.png',
        nameOfMember: 'Ayo Scott',
        serviceName: 'LEGAL ADVISER E.S'
    },
]

export const peerlessDataForTestimonial = [

    {
        id: 1,
        image: 't1.jpg',
        folder: 'Testimonials',
        Name: 'Revamping and Restyling Service',
        
        
    },

    {
        id: 2,
        image: 't2.jpg',
        folder: 'Testimonials',
        Name: 'Ring Light Purchase',
       
    },
]


export const peerlessDataForOurHair = [

    {
        id: 3,
        image: 'oh.png',
        name: 'Periwinkle Braid',
        folder: 'OurHairs'
        
        
    },

    {
        id: 4,
        image: 'oh1.png',
        name:  'Bob Marley',
        folder: 'OurHairs'
       
    },

      {
        id: 5,
        image: 'oh2.png',
        name: 'Braided Wig',
        folder: 'OurHairs'
        
        
    },

    {
        id: 6,
        image: 'oh3.png',
        name:  'Front View',
        folder: 'OurHairs'
       
    },

     {
        id: 7,
        image: 'oh4.png',
        name: 'Twisted Wig',
        folder: 'OurHairs'
        
        
    },

    {
        id: 8,
        image: 'oh5.png',
        name:  'Braided Wig',
        folder: 'OurHairs'
       
    },

      {
        id: 9,
        image: 'oh6.png',
        name: 'Styled Wig',
        folder: 'OurHairs'
        
        
    },

    {
        id: 10,
        image: 'oh7.png',
        name:  'Styled Wig',
        folder: 'OurHairs'
       
    },

     {
        id: 11,
        image: 'oh8.png',
        name: 'Twisted Wig',
        folder: 'OurHairs'
        
        
    },

    {
        id: 12,
        image: 'oh9.png',
        name:  'Weavon Wigging',
        folder: 'OurHairs'
       
    },

      {
        id: 13,
        image: 'oh10.png',
        name: 'Side View',
        folder: 'OurHairs'
        
        
    },

    {
        id: 14,
        image: 'oh11.png',
        name:  'Back View',
        folder: 'OurHairs'
       
    },

     {
        id: 15,
        image: 'oh12.png',
        name: 'RevampWigging',
        folder: 'OurHairs'
        
        
    },

    {
        id: 16,
        image: 'oh13.png',
        name:  'Wigging',
        folder: 'OurHairs'
       
    },

      {
        id: 17,
        image: 'oh14.png',
        name: 'Braid Style',
        folder: 'OurHairs'
        
        
    },

    {
        id: 18,
        image: 'oh15.png',
        name:  'Braid Style',
        folder: 'OurHairs'
       
    },
     {
        id: 19,
        image: 'oh16.png',
        name: 'Braid',
        folder: 'OurHairs'
        
        
    },

    {
        id: 20,
        image: 'oh17.png',
        name:  'Wig Install',
        folder: 'OurHairs'
       
    },

      {
        id: 21,
        image: 'oh18.png',
        name: 'Hair Twist',
        folder: 'OurHairs'
        
        
    },

    {
        id: 22,
        image: 'oh19.png',
        name:  'Styled Braid',
        folder: 'OurHairs'
       
    },

     {
        id: 23,
        image: 'oh20.png',
        name: 'Afro Wig',
        folder: 'OurHairs'
        
        
    },

    {
        id: 24,
        image: 'oh21.png',
        name:  'Afro Wig',
        folder: 'OurHairs'
       
    },

      {
        id: 25,
        image: 'oh22.png',
        name: 'Packing Gel',
        folder: 'OurHairs'
        
        
    },

    {
        id: 26,
        image: 'oh23.png',
        name:  'All Round Wig',
        folder: 'OurHairs'
       
    },

     {
        id: 27,
        image: 'oh24.png',
        name: 'Oblique View',
        folder: 'OurHairs'
        
        
    },

    {
        id: 28,
        image: 'oh25.png',
        name:  'RevampRestyle',
        folder: 'OurHairs'
       
    },

      {
        id: 29,
        image: 'oh26.png',
        name: 'Packing Gel Wig',
        folder: 'OurHairs'
        
        
    },

    {
        id: 30,
        image: 'oh27.png',
        name:  'Full Fringe',
        folder: 'OurHairs'
       
    },

     {
        id: 31,
        image: 'oh28.png',
        name: 'Wig Install',
        folder: 'OurHairs'
        
        
    },

    {
        id: 32,
        image: 'oh29.png',
        name:  'RevampRestyle',
        folder: 'OurHairs'
       
    },

      {
        id: 33,
        image: 'oh30.png',
        name: 'Packing Gel',
        folder: 'OurHairs'
        
        
    },

    {
        id: 34,
        image: 'oh31.png',
        name:  'Braided Wig',
        folder: 'OurHairs'
       
    },

     {
        id: 35,
        image: 'oh32.png',
        name: 'Back View',
        folder: 'OurHairs'
        
        
    },

    {
        id: 36,
        image: 'oh33.png',
        name:  'Oblique View',
        folder: 'OurHairs'
       
    },

      {
        id: 37,
        image: 'oh34.png',
        name: 'Crochet Install',
        folder: 'OurHairs'
        
        
    },

    {
        id: 38,
        image: 'oh35.png',
        name:  'Back View',
        folder: 'OurHairs'
       
    },

     {
        id: 39,
        image: 'oh36.png',
        name: 'Full Fringe',
        folder: 'OurHairs'
        
        
    },

    {
        id: 40,
        image: 'oh37.png',
        name:  'Braiding',
        folder: 'OurHairs'
       
    },

      {
        id: 41,
        image: 'oh38.png',
        name: 'Back View',
        folder: 'OurHairs'
        
        
    },

    {
        id: 42,
        image: 'oh39.png',
        name:  'RevampRestyle',
        folder: 'OurHairs'
       
    },
]

export const peerlessDataForOurWeaves = [

    {
        id: 43,
        image: 'wc0.png',
        name: 'Guide To Order',
        folder: 'Weavons',
        
        
    },

    {
        id: 44,
        image: 'wc1.png',
        name:  'Guide To Order',
        folder: 'Weavons',
       
    },

      {
        id: 45,
        image: 'wc2.png',
        name: 'Guide To Order',
        folder: 'Weavons',
        
        
    },

    {
        id: 46,
        image: 'wc3.png',
        name:  'Guide To Order',
        folder: 'Weavons',
       
    },

     {
        id: 47,
        image: 'wc4.png',
        name: 'Guide To Order',
        folder: 'Weavons',
        
        
    },

    {
        id: 48,
        image: 'wc5.png',
        name:  'Guide To Order',
        folder: 'Weavons',
       
    },

      {
        id: 49,
        image: 'wc6.png',
        name: 'Guide To Order',
        folder: 'Weavons',
        
        
    },

    {
        id: 50,
        image: 'wc7.png',
        name:  'Guide To Order',
        folder: 'Weavons',
       
    },

    
    {
        id: 51,
        image: 'wc9.png',
        name:  'Guide To Order',
        folder: 'Weavons',
       
    },

    
    {
        id: 52,
        image: 'wc10.png',
        name:  'Guide To Order',
        folder: 'Weavons',
       
    },
]

export const peerlessDataForOurCrochets = [

    {
        id: 53,
        image: 'c0.png',
        name: 'Braid',
        folder: 'crochets',
        
        
    },

    {
        id: 54,
        image: 'c1.png',
        name:  'Twisting',
        folder: 'crochets',
       
    },

      {
        id: 55,
        image: 'c2.png',
        name: 'Braid',
        folder: 'crochets',
        
        
    },

    {
        id: 56,
        image: 'c3.png',
        name:  'Braid',
        folder: 'crochets',
       
    },

     {
        id: 57,
        image: 'c4.png',
        name: 'Crochet',
        folder: 'crochets',
        
        
    },

    {
        id: 58,
        image: 'c5.png',
        name:  'Braid',
        folder: 'crochets',
       
    },

      {
        id: 59,
        image: 'c6.png',
        name: 'Crochet',
        folder: 'crochets',
        
        
    },

    {
        id: 60,
        image: 'c7.png',
        name:  'Crotchet Braid',
        folder: 'crochets',
       
    },

    

]

export const peerlessDataForRevampingAndRestyling = [

    {
        id: 61,
        image: 'vp1.png',
        name: 'Before',
        folder: 'RevampStyling',
        
        
    },

    {
        id: 62,
        image: 'vp2.png',
        name:  'After',
        folder: 'RevampStyling',
       
    },

      {
        id: 63,
        image: 'vp3.png',
        name: 'Before | After',
        folder: 'RevampStyling',
        
        
    },

    {
        id: 64,
        image: 'vp4.png',
        name:  'before | After',
        folder: 'RevampStyling',
    },
    
      {
        id: 65,
        image: 'vp5.jpeg',
        name: 'Before',
        folder: 'RevampStyling',
        
        
    },

    {
        id: 66,
        image: 'vp6.jpeg',
        name:  'After',
        folder: 'RevampStyling',
    }

    ,

    {
        id: 67,
        image: 'vp7.jpeg',
        name:  'Revamp',
        folder: 'RevampStyling',
    }
    ,

    {
        id: 116,
        image: 'vp8.jpeg',
        name:  'Revamp',
        folder: 'RevampStyling',
    },
]

export const peerlessDataForAccessories = [

    {
        id: 68,
        image: 'a0.png',
        name: 'Accessories',
        info: 'Attachment | Crochet',
        folder: 'Accessories',
        
        
    },

    {
        id: 69,
        image: 'a1.png',
        name: 'Accessories',
        info:  'Hair Brush | Set Of Comb | Rulers | Styling Stick | black Rubber Band | Wig Caps',
        folder: 'Accessories',
       
    },

      {
        id: 70,
        image: 'a2.png',
        name: 'Accessories',
        info: 'Adhesive Gum | Got2bGlue Gel | Got2bGlue Spray | Stretcher',
        folder: 'Accessories',
        
        
    },

    {
        id: 71,
        image: 'a3.png',
        name: 'Accessories',
        info:  'Maniquin Shoulder | Canvas Head',
        folder: 'Accessories',
    },
    
      {
        id: 72,
        image: 'a4.png',
        name: 'Accessories',
        info: 'Dera Conditioning Shampoo | Dera Instant Conditional | So-Fine(Weave-On Oil) | Mediana Leave-In Conditioning Milk | Medi Care Weavon Super Gloss | Olive Oil Hair Mayonnaise | Original Hair Mayonnaise | Extra Virgin Olive Oil',
        folder: 'Accessories',
        
        
    },

    {
        id: 73,
        image: 'a5.png',
        name: 'Accessories',
        info:  'Ring Light | Tripple Stand for Dummies',
        folder:'Accessories',
    }

    ,

    {
        id: 74,
        image: 'a6.png',
        name: 'Accessories',
        info:  'Hot Comb | Big Hand Dryer',
        folder: 'Accessories',
    }

     ,

    {
        id: 75,
        image: 'a7.png',
        name: 'Accessories',
        info:  'Mini Hard Dryer | Mini Fan | Dummy Head | Mini Stretcher',
        folder: 'Accessories',
    }
    
]

export const peerlessDataForOurBraids = [

    {
        id: 76,
        image: 'b0.png',
        name: 'Order Now',
        folder: 'Braids',
        
        
    },

    {
        id: 77,
        image: 'b1.png',
        name:  'Home Service',
        folder: 'Braids',
       
    },

      {
        id: 78,
        image: 'b2.png',
        name: 'Home Service',
        folder: 'Braids',
        
        
    },

    {
        id: 79,
        image: 'b3.png',
        name:  'Home Service',
        folder: 'Braids',
       
    },

     {
        id: 80,
        image: 'b4.png',
        name: 'Order Now',
        folder: 'Braids',
        
        
    },

    {
        id: 81,
        image: 'b5.png',
        name:  'Order Now',
        folder: 'Braids',
       
    },

      {
        id: 82,
        image: 'b6.png',
        name: 'Order Now',
        folder: 'Braids',
        
        
    },

    {
        id: 83,
        image: 'b7.png',
        name:  'Lace Cap Wig',
        folder: 'Braids',
       
    },

     {
        id: 84,
        image: 'b8.png',
        name:  'Home Service',
        folder: 'Braids',
       
    },

     {
        id: 85,
        image: 'b9.png',
        name:  'Home Service',
        folder: 'Braids',
       
    },

]

export const peerlessDataEflyers = [

    {
        id: 86,
        image: 'e1.png',
        name: 'Graphic Design',
        folder: 'eflyers',
        
        
    },

    {
        id: 87,
        image: 'e2.png',
        name:  'Empty Template',
        folder: 'eflyers',
       
    },

      {
        id:88,
        image: 'e3.png',
        name: 'Empty Template',
        folder: 'eflyers',
        
        
    },

    {
        id: 89,
        image: 'e4.png',
        name:  'Luggage Sales',
        folder: 'eflyers',
       
    },

     {
        id: 90,
        image: 'e5.png',
        name: 'Laptop Sales',
        folder: 'eflyers',
        
        
    },

    {
        id: 91,
        image: 'e6.png',
        name:  'Digital Marketing',
        folder: 'eflyers',
       
    },

      {
        id: 92,
        image: 'e7.png',
        name: 'Fashion',
        folder: 'eflyers',
        
        
    },

    {
        id: 93,
        image: 'e8.png',
        name:  'Training',
        folder: 'eflyers',
       
    },

]

export const peerlessDataForBanAndLetter = [

 

    {
        id: 94,
        image: 'b1.png',
        name:  'Banner',
        folder: 'banAndLetter',
       
    },

      {
        id: 95,
        image: 'b2.png',
        name:  'Banner',
        folder: 'banAndLetter',
        
        
    },

    {
        id: 96,
        image: 'b3.png',
        name:  'Banner',
        folder: 'banAndLetter',
       
    },

     {
        id: 97,
        image: 'b4.png',
        name:  'Banner',
        folder: 'banAndLetter',
        
        
    },

    {
        id: 98,
        image: 'b5.png',
        name:  'Letter Head',
        folder: 'banAndLetter',
       
    },

      {
        id: 99,
        image: 'b6.png',
        name:  'Letter Head',
        folder: 'banAndLetter',
        
        
    },

   

]


export const peerlessDataForLogos = [

 

    {
        id: 100,
        image: 'l1.jpg',
        name:  'Spar',
        folder: 'logos',
       
    },

      {
        id: 101,
        image: 'l2.jpg',
        name:  'cloth Manager',
        folder: 'logos',
        
        
    },

    {
        id: 102,
        image: 'l3.jpg',
        name:  'Cleaning Service',
        folder: 'logos',
       
    },

     {
        id: 103,
        image: 'l4.jpg',
        name:  'Hair Service',
        folder: 'logos',
        
        
    },

    {
        id: 104,
        image: 'l5.jpg',
        name:  'Catering Service',
        folder: 'logos',
       
    },

      {
        id: 105,
        image: 'l6.jpg',
        name:  'Lingery Sales',
        folder: 'logos',
       
    },
    
      {
        id: 106,
        image: 'l7.jpg',
        name:  'Spar',
        folder: 'logos',
       
    },

]

export const peerlessDataForBrandAndId = [

 

    {
        id: 107,
        image: 'p1.png',
        name:  'Beverages',
        folder: 'brandAndId',
       
    },

      {
        id: 108,
        image: 'p2.png',
        name:  'Car',
        folder: 'brandAndId',
        
        
    },

    {
        id: 109,
        image: 'p3.png',
        name:  'Bag',
        folder: 'brandAndId',
       
    },

     {
        id: 110,
        image: 'p4.png',
        name:  'Microwave Oven',
        folder: 'brandAndId',
        
        
    },

    {
        id: 111,
        image: 'p5.png',
        name:  'Business ID',
        folder: 'brandAndId',
       
    },

      {
        id: 112,
        image: 'p6.png',
        name:  'Business ID',
        folder: 'brandAndId',
       
    },
    
    
]

export const peerlessDataForVids = [

 

    {
        id: 113,
        image: 'v1.png',
        name:  'We Provide Software Solutions',
        folder: 'VidLinks',
       
    },

      {
        id: 114,
        image: 'v2.png',
        name:  'We Design Web Applications',
        folder: 'VidLinks',
        
        
    },

    {
        id: 115,
        image: 'v3.png',
        name:  'We Design Web Sites',
        folder: 'VidLinks',
       
    },

]
